import nxModule from 'nxModule';

nxModule.factory('customReportSaved', (CacheFactory) =>
  CacheFactory.createCache('customReportSaved', {
    storageMode: 'localStorage',
    storagePrefix: 'nx__nonvolatile__',
  })
);